import { mapGetters } from "vuex";

export default {
    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        vuexModule: {
            default: null,
            required: false,
            type: String,
        },
    },

    /**
     * Set the computed variables
     *
     * @type  {object}
     */
    computed: {
        /**
         * Create the ui getter based on the vuexModule prop. Defaults to ui/ui
         *
         * @return  {object}
         */
        ui() {
            const getterName = this.vuexModule
                ? `${this.vuexModule}/${this.vuexModule}`
                : "ui/ui";
            return this.$store.getters[getterName];
        },
    },
};
